import React, { useState, useEffect } from 'react';
import apiService from '../services/ApiService';

const DeletionLogModal = ({ isOpen, onClose, currentUser }) => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchLogs = React.useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await apiService.getDeletionLogs(currentUser?.username, currentUser?.role);
            if (result.success) {
                setLogs(result.data);
            } else {
                setError(result.error);
            }
        } catch (err) {
            setError('Failed to fetch logs');
        } finally {
            setLoading(false);
        }
    }, [currentUser]);

    useEffect(() => {
        if (isOpen) {
            fetchLogs();
        }
    }, [isOpen, fetchLogs]);

    if (!isOpen) return null;

    return (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            <i className="fas fa-history me-2"></i>
                            ประวัติการลบข้อมูล
                        </h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        {loading ? (
                            <div className="text-center py-4">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : error ? (
                            <div className="alert alert-danger">{error}</div>
                        ) : logs.length === 0 ? (
                            <div className="text-center py-4 text-muted">
                                ไม่พบประวัติการลบข้อมูล
                            </div>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th>วันที่ลบ</th>
                                            <th>ผู้ลบ</th>
                                            <th>ประเภท</th>
                                            <th>รายละเอียด</th>
                                            <th>เหตุผล</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {logs.map((log) => {
                                            let details = {};
                                            try {
                                                details = typeof log.details === 'string' ? JSON.parse(log.details) : log.details;
                                            } catch (e) { }

                                            return (
                                                <tr key={log.id}>
                                                    <td>{new Date(log.deleted_at).toLocaleString('th-TH')}</td>
                                                    <td>{log.deleted_by}</td>
                                                    <td>
                                                        <span className="badge bg-secondary">{log.entity_type}</span>
                                                    </td>
                                                    <td>
                                                        <small>
                                                            {details.saleNumber && <div>เลขที่: {details.saleNumber}</div>}
                                                            {details.customerName && <div>ลูกค้า: {details.customerName}</div>}
                                                            {details.saleAmount && <div>ยอด: {parseFloat(details.saleAmount).toLocaleString()}</div>}
                                                        </small>
                                                    </td>
                                                    <td className="text-danger">{log.reason}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            ปิด
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeletionLogModal;
